/**
 * Ce qu'un enregistreur dit de son arrêt (`notice`), le même dans la feuille (`<VoiceRecorderSheet>`)
 * et dans la carte (`<InlineVoiceRecorder>`) : la durée maximale atteinte, l'app quittée, un vocal
 * trop court.
 */
import { type UIVoiceRecorderNotice } from "../../../ports/primary/ui/types/studentVoice"

/** Le plafond de l'enregistreur (`engine/voice`) : 12 minutes. */
export const DEFAULT_MAX_DURATION_MS = 12 * 60 * 1000

/** « 12 minutes », « 30 secondes » : le plafond, en mots. */
function durationWords(ms: number): string {
    const seconds = Math.round(ms / 1000)
    if (seconds % 60 !== 0) return `${seconds} secondes`
    const minutes = seconds / 60
    return minutes === 1 ? "1 minute" : `${minutes} minutes`
}

export function recorderNoticeText(
    notice: UIVoiceRecorderNotice | null | undefined,
    maxDurationMs: number = DEFAULT_MAX_DURATION_MS,
    tooShortMessage?: string
): string | null {
    switch (notice) {
        case "max_duration":
            return `Durée maximale atteinte (${durationWords(maxDurationMs)}). Ton enregistrement est gardé.`
        case "background":
            return "L'enregistrement s'est arrêté quand tu as quitté l'app. Il est gardé."
        case "too_short":
            return tooShortMessage ?? "C'est un peu court : continue encore un peu."
        default:
            return null
    }
}
